import React from 'react';

// Usado para encapsular o conteúdo principal das páginas quem contém tabelas, fornecendo um estilo consistente e facilitando a manutenção do layout.
const PageContent = ({ children, className = '', style = {} }) => {
  const defaultStyle = {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    overflowX: 'hidden',
    minHeight: 0,
    ...style,
  };

  return (
    <div className={`card-body p-2 ${className}`} style={defaultStyle}>
      {children}
    </div>
  );
};

export default PageContent;
